import { useQuery } from "@apollo/client";
import { getEnvironment } from "@clockwise/client-commons/src/config/environment";
import { getValue } from "@clockwise/client-commons/src/util/errorable.util";
import { getAnalyticsId, shouldTrack } from "@clockwise/web-commons/src/util/analytics.util";
import { FullStoryQueryDocument } from "@clockwise/web-commons/src/util/graphql/__generated__/FullStory.generated";
import * as FullStory from "@fullstory/browser";
import { noop } from "lodash";

const FULLSTORY_ORG_ID = "o-1QKH15-na1";

const fsInit = () => {
  FullStory.init({ orgId: FULLSTORY_ORG_ID });
};

const fsIdentify = (userProperties: FullStory.UserVars) => {
  FullStory.identify(getAnalyticsId(), userProperties);
};

const fsConsent = () => {
  FullStory.consent();
};

const fsTrack = (
  eventName: string,
  eventProperties: {
    [key: string]: any;
  },
) => {
  FullStory.event(eventName, eventProperties);
  const playbackAtThisMomentInTime = FullStory.getCurrentSessionURL(true);

  return playbackAtThisMomentInTime;
};

export const useFullStory = () => {
  const isProd = getEnvironment() === "production";

  const { data, loading } = useQuery(FullStoryQueryDocument, {
    skip: !isProd,
  });

  if (!isProd || !shouldTrack()) {
    return {
      fsInit: noop,
      fsIdentify: noop,
      fsConsent: noop,
      fsTrack: noop,
      fsLoading: false,
    };
  }

  const viewer = getValue(data?.viewer, "Viewer");
  const user = getValue(viewer?.user, "User");
  const org = getValue(user?.orgs)?.edges?.[0]?.node;

  return {
    fsInit,
    fsIdentify: () => {
      fsIdentify({
        displayName: `${user?.givenName} ${user?.familyName}`,
        email: org?.primaryOrgEmail,
      });
    },
    fsConsent,
    fsTrack,
    fsLoading: loading,
  };
};
